import { useCallback, useRef } from 'react';

import { cleanupUnusedBlobUrls, revokeBlobUrl } from './utils';

/**
 * Hook to manage blob URL lifecycle and cleanup
 */
export const useBlobUrlManagement = () => {
  const blobUrlsRef = useRef<Map<string, string>>(new Map()); // mxcUri -> blobUrl

  const cleanupAllBlobUrls = useCallback(() => {
    blobUrlsRef.current.forEach(revokeBlobUrl);
    blobUrlsRef.current.clear();
  }, []);

  const cleanupUnusedBlobUrlsFn = useCallback((currentMxcUris: Set<string>) => {
    cleanupUnusedBlobUrls(blobUrlsRef, currentMxcUris);
  }, []);

  return {
    blobUrlsRef,
    cleanupAllBlobUrls,
    cleanupUnusedBlobUrlsFn,
  };
};
